import { type Dispatch, type RefObject, type SetStateAction, useEffect } from 'react';

import type { SearchDropdownPosition } from '../types';

interface UseSearchDropdownPositionParams {
  variant: 'mobile' | 'desktop';
  showDropdown: boolean;
  searchQuery: string;
  inputRef: RefObject<HTMLInputElement | null>;
  setDropdownPosition: Dispatch<SetStateAction<SearchDropdownPosition>>;
}

/** Для desktop-dropdown считает fixed-позицию относительно input. */
export function useSearchDropdownPosition({
  variant,
  showDropdown,
  searchQuery,
  inputRef,
  setDropdownPosition,
}: UseSearchDropdownPositionParams): void {
  useEffect(() => {
    const updateDropdownPosition = () => {
      if (variant === 'desktop' && inputRef.current && showDropdown) {
        const rect = inputRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + 8,
          left: rect.left,
          width: rect.width,
        });
      }
    };

    if (variant === 'desktop' && showDropdown) {
      updateDropdownPosition();
      window.addEventListener('scroll', updateDropdownPosition, true);
      window.addEventListener('resize', updateDropdownPosition);
      return () => {
        window.removeEventListener('scroll', updateDropdownPosition, true);
        window.removeEventListener('resize', updateDropdownPosition);
      };
    }
  }, [showDropdown, variant, searchQuery, inputRef, setDropdownPosition]);
}
